module.exports = __webpack_public_path__ + "static/media/ReportToManagement.3d56083c.svg";